module.exports = fox._r("fonts/mc_icons-webfont.woff", __webpack_public_path__ + "_/_/_/root/fonts/2qaP9fR.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/mc_icons-webfont.woff
// module id = 211
// module chunks = 4